export default __webpack_public_path__ + "static/media/Penny2.a7547612.png";